import { ProgressCircle } from "./ProgressCircle";

const tableHeaders = [
  "Skills Experience",
  "Your Match",
];

const skills = [
  {
    skill: "React",
    level: "Advanced",
    expRequirement: "3+ years",
    lastUsed: "Within last 6 months",
    matchPercentage: 92,
  },
];

const SkillsTable = () => {
  return (
    <div className="rounded-md border">
      {/* Table header */}
      <div className="grid grid-cols-[1.25fr_1.25fr_0.5fr] bg-gray-50 p-2">
        {tableHeaders?.map((header) => {
          return <span className="text-xss font-semibold">{header}</span>;
        })}
      </div>
      {/* Table body  */}
      {Array.from({ length: 10 })?.map((_, index) => {
        return (
          <div
            key={index}
            className="grid grid-cols-[1.25fr_1.25fr_0.5fr] py-1 border-t px-3 items-center"
          >
            <span className="text-xss font-semibold">React</span>
        
            <ProgressCircle size={35} strokeWidth={2} percentage={100/index}/>

            <button className="ml-auto border rounded-md text-blue-700 font-bold text-xss w-max px-4 py-1">
              View details
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default SkillsTable;
